// External Libraries
import React from 'react';
import { useNavigate } from 'react-router-dom';

// Assets
import leftArrow from '../assets/left-arrow.png';

// Components
import Label from './common/Label';
import Text from './common/Text';
import Button from './common/Button';

const TermsandConditions: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="p-20 custom-background grid gap-10">
      <div className="nav-bar">
        <Button
          type="button"
          className="nav-button"
          onClick={() => navigate(-1)}
          aria-label="ideas navigation"
        >
          <img src={leftArrow} alt="left-icon" className="left-arrow-icon" />
        </Button>
      </div>
      <Text className="screen-header">BUILT Platform Terms and Conditions</Text>
      <div className="grid gap-15">
        <div style={{ display: 'flex', flexDirection: 'row', flex: 1 }}>
          <div className="section-head">Last Updated: </div>
          <div className="section-data">10-01-2024</div>
        </div>
        <Text className="section-data">
          Welcome to BUILT, a platform designed to connect and foster
          collaboration among the University of Virginia&apos;s faculty,
          students, alumni, and sponsors to drive innovation and
          commercialization of university-generated ideas. By registering and
          using the BUILT platform, you agree to comply with the following Terms
          and Conditions, which are designed to protect your ideas and ensure a
          respectful, collaborative environment.
        </Text>
        <Label className="section-head">1. Acceptance of Terms</Label>
        <Text className="section-data">
          By accessing or using the BUILT platform, you agree to be bound by
          these Terms and Conditions. If you do not agree with these terms, you
          should not use the platform.
        </Text>

        <Label className="section-head">
          2. Confidentiality and Non-Disclosure
        </Label>
        <ul className="mb-0">
          <li>
            <Text className="font-weight-700">
              Protection of Shared Information:
            </Text>{' '}
            Any information (collectively, &quot;Confidential Information&quot;)
            shared on the BUILT BUILT platform is considered confidential and
            should not be disclosed used for any purpose outside of the intended
            collaboration on the platform.
          </li>
          <li>
            <Text className="font-weight-700">Non-Disclosure Agreement:</Text>{' '}
            By using the BUILT platform, you agree not to copy, share, use, or
            otherwise disclose any Confidential Information without the express
            permission of the original poster.
          </li>
          <li>
            <Text className="font-weight-700">Limited Use:</Text> Confidential
            Information may only be used for collaboration, mentoring, or other
            activities directly related to the goals of BUILT.
          </li>
        </ul>

        <Label className="section-head">3. User Responsibilities</Label>
        <ul className="mb-0">
          <li>
            <Text className="font-weight-700">
              Respect for Intellectual Property:
            </Text>{' '}
            Respect the intellectual property rights of others. Do not post any
            content that you do not have the right to disclose.
          </li>
          <li>
            <Text className="font-weight-700">No Reverse Engineering:</Text> Do
            not attempt to reverse engineer, disassemble, or decompile any
            content or data on the platform.
          </li>
          <li>
            <Text className="font-weight-700">Reporting Misuse:</Text> Promptly
            report any misuse of Confidential Information.
          </li>
        </ul>

        <Label className="section-head">4. Ownership of Content</Label>
        <ul className="mb-0">
          <li>
            <Text className="font-weight-700">Your Content:</Text> You retain
            ownership of any content, ideas, or intellectual property that you
            post on the platform, but grant BUILT a non-exclusive, revocable
            license to use your content for collaboration.
          </li>
          <li>
            <Text className="font-weight-700">Third-Party Content:</Text> Use
            third-party content in accordance with these terms.
          </li>
        </ul>

        <Label className="section-head">
          5. No Guarantee of Confidentiality by BUILT
        </Label>
        <Text className="section-data">
          BUILT takes measures to encourage confidentiality but cannot guarantee
          it. You share content at your own risk.
        </Text>

        <Label className="section-head">
          6. Termination and Consequences of Breach
        </Label>
        <ul className="mb-0">
          <li>
            <Text className="font-weight-700">Termination of Access: </Text>
            BUILT reserves the right to terminate your access if you are found
            to be in breach of these Terms and Conditions.
          </li>
          <li>
            <Text className="font-weight-700">Legal Consequences: </Text>
            Breaches of confidentiality may result in legal action.
          </li>
        </ul>

        <Label className="section-head">7. General Provisions</Label>
        <ul className="mb-0">
          <li>
            <Text className="font-weight-700"> Modifications to Terms: </Text>
            BUILT reserves the right to modify these Terms and Conditions at any
            time.
          </li>
          <li>
            <Text className="font-weight-700">Governing Law: </Text>
            These terms shall be governed by the laws of Virginia.
          </li>
          <li>
            <Text className="font-weight-700">Entire Agreement: </Text>
            These Terms and Conditions constitute the entire agreement between
            you and BUILT.
          </li>
        </ul>

        <Text className="section-data">
          By continuing to use the BUILT platform, you acknowledge that you
          agree to these Terms and Conditions.
        </Text>
      </div>
    </div>
  );
};

export default TermsandConditions;
